import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AdminRoute from "@/components/AdminRoute";
import ClientRoute from "@/components/ClientRoute";
import AppLayout from "@/components/AppLayout";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import ClientesPage from "@/pages/ClientesPage";
import MotosPage from "@/pages/MotosPage";
import ServicosPage from "@/pages/ServicosPage";
import BackofficePage from "@/pages/BackofficePage";
import OficinaSettingsPage from "@/pages/OficinaSettingsPage";
import AdminReviewsPage from "@/pages/AdminReviewsPage";
import AdminClientesPendentesPage from "@/pages/AdminClientesPendentesPage";
import AdminSlotsPage from "@/pages/AdminSlotsPage";
import RelatoriosPage from "@/pages/RelatoriosPage";
import TrackingPage from "@/pages/TrackingPage";
import PublicReviewsPage from "@/pages/PublicReviewsPage";
import LandingPage from "@/pages/LandingPage";
import ClientLoginPage from "@/pages/ClientLoginPage";
import ClientRegisterPage from "@/pages/ClientRegisterPage";
import ClientDashboardPage from "@/pages/ClientDashboardPage";

function App() {
    return (
        <div className="App">
            <AuthProvider>
                <BrowserRouter>
                    <Routes>
                        {/* Public */}
                        <Route path="/" element={<LandingPage />} />
                        <Route path="/entrar" element={<ClientLoginPage />} />
                        <Route path="/registar" element={<ClientRegisterPage />} />
                        <Route path="/login" element={<LoginPage />} />
                        <Route path="/track/:token" element={<TrackingPage />} />
                        <Route path="/avaliacoes" element={<PublicReviewsPage />} />

                        {/* Client area */}
                        <Route
                            path="/minha-conta"
                            element={
                                <ClientRoute>
                                    <ClientDashboardPage />
                                </ClientRoute>
                            }
                        />

                        {/* Staff area (admin + operador) */}
                        <Route
                            element={
                                <ProtectedRoute>
                                    <AppLayout />
                                </ProtectedRoute>
                            }
                        >
                            <Route path="/dashboard" element={<DashboardPage />} />
                            <Route path="/clientes" element={<ClientesPage />} />
                            <Route path="/motos" element={<MotosPage />} />
                            <Route path="/servicos" element={<ServicosPage />} />
                            <Route
                                path="/backoffice"
                                element={<AdminRoute><BackofficePage /></AdminRoute>}
                            />
                            <Route
                                path="/backoffice/oficina"
                                element={<AdminRoute><OficinaSettingsPage /></AdminRoute>}
                            />
                            <Route
                                path="/backoffice/avaliacoes"
                                element={<AdminRoute><AdminReviewsPage /></AdminRoute>}
                            />
                            <Route
                                path="/backoffice/aprovacoes"
                                element={<AdminRoute><AdminClientesPendentesPage /></AdminRoute>}
                            />
                            <Route
                                path="/backoffice/disponibilidade"
                                element={<AdminRoute><AdminSlotsPage /></AdminRoute>}
                            />
                            <Route
                                path="/backoffice/relatorios"
                                element={<AdminRoute><RelatoriosPage /></AdminRoute>}
                            />
                        </Route>

                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </BrowserRouter>
                <Toaster richColors position="top-right" />
            </AuthProvider>
        </div>
    );
}

export default App;
